import s from "styled-components";

export const Wrap = s.div`
  outline: none;
  cursor: pointer;
`;
export const Pic = s.img`
  position: relative;
  top: -1px;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
  width: 100%;
  height: auto;
  display: block;
`;
